import { render } from "./Resetpassword.vue?vue&type=template&id=09a3aa34&scoped=true"
import script from "./Resetpassword.vue?vue&type=script&lang=js"
export * from "./Resetpassword.vue?vue&type=script&lang=js"

import "./Resetpassword.vue?vue&type=style&index=0&id=09a3aa34&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a3aa34"]])

export default __exports__